import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Telegram: React.FC<IconProps> = ({
  color = '#0088cc',
  size = 24,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.568 8.16l-1.614 7.61c-.121.563-.441.7-.894.436l-2.478-1.826-1.194 1.15c-.132.132-.243.243-.5.243l.178-2.527L15.952 9.24c.198-.177-.043-.275-.307-.098l-4.576 2.88-1.97-.616c-.428-.134-.437-.428.089-.633l7.701-2.967c.357-.133.669.08.555.632l.124.722z"
      fill={color}
    />
  </svg>
)
